module.exports = __webpack_public_path__ + "img/1440.366f2b7b.jpg";